import { createSeniorFlowTab } from './seniorFlowTabFactory';
import { registerTab } from './tabRegistry';

// senior_level_flow — "Failed" tab (shown to the TA as "Closed", per the
// flow-statuses API's own tabs[].name — that tab's own filters.status is
// ["Failed", "Not Interested", "No Show", "Non Responsive"], so it also
// covers those three terminal sub-statuses). manual_actions:
// move_to_shortlisted.
const SeniorFailedTab = createSeniorFlowTab(
  'Failed',
  'No candidates have failed this stage yet.'
);

registerTab({
  stateMachineKey: 'senior_level_flow',
  state: 'Failed',
  component: SeniorFailedTab,
});

export default SeniorFailedTab;
